module.exports = __webpack_public_path__ + "img/bg_redian_2.f55d0303.png";